import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDyTCS9MEtREGAOTZZOWlwCJF4fycxyE0o",
  authDomain: "micro-gestor.firebaseapp.com",
  projectId: "micro-gestor",
  storageBucket: "micro-gestor.firebasestorage.app",
  messagingSenderId: "918159905094",
  appId: "1:918159905094:web:5799afda2c6791a3609547",
  measurementId: "G-NYCVYZTKHF"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
